import { useSnapshot } from 'valtio';
import { userStatusState } from '../state';
import { UserStatusState } from '../types';

let mockedUserStatus: UserStatusState | null = null;

export function setMockedUserStatus(userStatus: Partial<UserStatusState>) {
  mockedUserStatus = { ...userStatusState, ...userStatus };
}

export function clearMockedUserStatus() {
  mockedUserStatus = null;
}

/**
 * Returns recovery time and loading states for user status wrap-up functionality.
 *
 * This hook provides access to the recovery time (when wrap-up ends) and
 * the loading state for refreshing user status during wrap-up periods.
 */
function useUserStatus() {
  const state = useSnapshot(userStatusState);

  if (mockedUserStatus) {
    return {
      recoveryTimeEndsAt: mockedUserStatus.recoveryTimeEndsAt,
      refreshUserStatusLoading: mockedUserStatus.refreshUserStatusLoading,
    };
  }

  return {
    recoveryTimeEndsAt: state.recoveryTimeEndsAt,
    refreshUserStatusLoading: state.refreshUserStatusLoading,
  };
}

export default useUserStatus;
